// Daily tracking utilities using AOE timezone (UTC-12)
// Consistent with weekly leaderboard system

// Helper function to get current AoE day key (e.g., '2025-01-15')
export function getAoeDayKey(date = new Date()) {
  // Convert to AoE time (UTC-12)
  const aoeDate = new Date(date.getTime() - 12 * 60 * 60 * 1000);
  return aoeDate.toISOString().split('T')[0]; // Returns YYYY-MM-DD
}

// Get start of day in AoE (midnight AoE time converted to UTC)
export function getDayStartTimeAoe(date = new Date()) {
  const aoeDate = new Date(date.getTime() - 12 * 60 * 60 * 1000); // Convert to AoE
  const dayStartAoe = new Date(aoeDate);
  dayStartAoe.setUTCHours(0, 0, 0, 0);
  // Convert back to UTC by adding 12 hours
  return new Date(dayStartAoe.getTime() + 12 * 60 * 60 * 1000);
}

// Get end of day in AoE (23:59:59.999 AoE time converted to UTC)
export function getDayEndTimeAoe(date = new Date()) {
  const aoeDate = new Date(date.getTime() - 12 * 60 * 60 * 1000); // Convert to AoE
  const dayEndAoe = new Date(aoeDate);
  dayEndAoe.setUTCHours(23, 59, 59, 999);
  // Convert back to UTC by adding 12 hours
  return new Date(dayEndAoe.getTime() + 12 * 60 * 60 * 1000);
}

// Check if it's a new day since last active date
export function isNewDay(lastActiveDate) {
  if (!lastActiveDate) return true;
  
  const today = getAoeDayKey();
  const lastActive = getAoeDayKey(lastActiveDate.toDate ? lastActiveDate.toDate() : lastActiveDate);
  
  return today !== lastActive;
}

// Debug helper
window.dailyUtilsDebug = {
  getAoeDayKey,
  getDayStartTimeAoe,
  getDayEndTimeAoe,
  isNewDay
};